import instance from "../utils/network";

export enum PaymentMethod {
  CASH = "CASH", // 현금
  CARD = "CARD", // 카드
  BANK_TRANSFER = "BANK_TRANSFER", // 계좌이체
  POINTS = "POINTS", // 포인트
  OTHER = "OTHER", // 기타
  DISCOUNT = "DISCOUNT",
  SEED = "SEED", // 시드
}

export enum EntryType {
  BUY_IN = "BUY_IN", // 바이인
  RE_BUY = "RE_BUY", // 리엔트리
  ADD_ON = "ADD_ON", // 애드온
}
export interface TournamentParticipantPaymentRequest {
  paymentMethod: PaymentMethod;
  paymentAmount: number;
}

export interface TournamentParticipantRequest {
  memberId: number;
  pubId: number;
  tournamentId: number;
  level: number;
  entryType: EntryType;
  paymentMethodRequests: TournamentParticipantPaymentRequest[];
  description: string;
}

// 저장할 때
export interface TournamentParticipantAndDeleteRequest {
  requests: TournamentParticipantRequest[];
  memberId: number;
  isCount: boolean; // 에드온일 때 true
}

export interface TournamentParticipationResponse {
  list: TournamentParticipationDto[];
  total: number;
  totalSitIn: number;
  totalSitOut: number;
}

export interface TournamentParticipationDto {
  id: number;
  memberId: number;
  rebuyCount: number;
  addonCount: number;
  nickname: string;
  addonIsCount: number;
  addonNotCount: number;
  isSitout: boolean;
}

export interface ParticipantPaymentRequest {
  paymentMethod: PaymentMethod;
  paymentAmount: number;
}

export interface TournamentReservationParticipantRequest {
  currentReservationId: number;
  memberId: number;
  pubId: number;
  tournamentId: number;
  level: number;
  description: string;
}
export interface ParticipantPaymentResponse {
  paymentMethod: PaymentMethod;
  amount: number;
}
export interface ParticipantDto {
  id: number;
  paymentMethodRequests: ParticipantPaymentRequest[];
  paymentAmount: number;
  createdAt: Date;
  level: number;
  memberId: number;
  pubId: number;
  tournamentId: number;
  entryType: EntryType;
  isCount?: boolean;
  addStack?: number;
  stack?: number;
}

export interface ParticipantHistoryDto {
  id: number;
  isCount: boolean;
  participantPaymentMethod: ParticipantPaymentResponse[];
  paymentAmount: number;
  createdAt: Date;
  level: number;
  memberId: number;
  pubId: number;
  tournamentId: number;
  entryType: EntryType;
  addStack: number;
  stack: number;
}

export function participantTournament(
  req: TournamentParticipantRequest,
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/tournament-participant/entry`, req);
}

export function reservationParticipation(
  request: TournamentReservationParticipantRequest,
): Promise<{ code: number; message: any }> {
  return instance.post(
    `/seller/tournament-participant/entry/reservation`,
    request,
  );
}

export function participantDeleteTournament(
  memberId: number,
  tournamentId: number,
): Promise<{ code: number; message: any }> {
  return instance.delete(`/seller/tournament-participant/entry`, {
    data: {
      memberId,
      tournamentId,
    },
  });
}

export function reBuyInOrAddOnDeleteTournament(
  id: number,
): Promise<{ code: number; message: any }> {
  return instance.delete(`/seller/tournament-participant/all/${id}`);
}

export function reBuyInTournament(
  req: TournamentParticipantAndDeleteRequest,
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/tournament-participant/re-buy-in`, req);
}

export function addOnTournament(
  req: TournamentParticipantAndDeleteRequest,
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/tournament-participant/add-on`, req);
}

export function getTournamentUserHistory(
  mId: number,
  tId: number,
): Promise<ParticipantHistoryDto[]> {
  return instance.get(
    `/seller/tournament-participant/history/all?memberId=${mId}&tournamentId=${tId}`,
  );
}

export function getTournamentUserReBuyInHistory(
  mId: number,
  tId: number,
): Promise<ParticipantHistoryDto[]> {
  return instance.get(
    `/seller/tournament-participant/history/re-buy-in?memberId=${mId}&tournamentId=${tId}`,
  );
}

export function getTournamentUserAddOnHistory(
  mId: number,
  tId: number,
): Promise<ParticipantHistoryDto[]> {
  return instance.get(
    `/seller/tournament-participant/history/add-on?memberId=${mId}&tournamentId=${tId}`,
  );
}

export function getTournamentUser(
  id: number,
  page: number = 1,
  limit: number = 50,
  search?: string,
): Promise<TournamentParticipationResponse> {
  return instance.get(
    `/seller/tournament-participant/all/${id}?page=${page}&limit=${limit}${
      search ? `&search=${search}` : ""
    }`,
  );
}

export function getTournamentUserIsSitOut(
  id: number,
  isSitOut: boolean,
  page: number = 1,
  limit: number = 20,
  search?: string,
  sort?: string,
): Promise<TournamentParticipationResponse> {
  return instance.get(
    `/seller/tournament-participant/is-sit-out/${id}?page=${page}&limit=${limit}&search=${search}&isSitOut=${isSitOut}&sort=${sort}`,
  );
}
